import React, { lazy } from 'react';
import { Route } from 'react-router';

const EditItem = lazy(
  () => import('legacy-src/components/questionBank/editor/EditItem/EditItem'),
);

export default (
  <Route
    name="createNewItem"
    path="author/question"
    component={EditItem}
    onLeave={EditItem.willTransitionFrom}
  />
);
